import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import { FiCheck, FiX } from "react-icons/fi";

const ImageCropModal = ({ image, aspect = 16 / 9, onCancel, onCropComplete }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropChange = (crop) => setCrop(crop);
    const onZoomChange = (zoom) => setZoom(zoom);

    const onCropCompleteHandler = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const createCroppedImage = async () => {
        const croppedImageBlob = await getCroppedImg(image, croppedAreaPixels);
        onCropComplete(croppedImageBlob);
    };

    return (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
            <div className="dark:bg-[#1A1A1A] bg-white p-4 rounded-xl shadow-lg w-[90%] md:w-[500px]">
                <div className="relative w-full h-80 bg-black">
                    <Cropper
                        image={image}
                        crop={crop}
                        zoom={zoom}
                        aspect={aspect}
                        onCropChange={onCropChange}
                        onZoomChange={onZoomChange}
                        onCropComplete={onCropCompleteHandler}
                    />
                </div>

                <div className="flex justify-between mt-4">
                    <button onClick={onCancel} className="border-primary border px-4 py-2 rounded-lg flex items-center gap-2 dark:text-white text-black">
                        <FiX /> Cancel
                    </button>
                    <button onClick={createCroppedImage} className="bg-primary text-white px-4 py-2 rounded-lg flex items-center gap-2">
                        <FiCheck /> Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropModal;


// Helper function to crop image from canvas
async function getCroppedImg(imageSrc, pixelCrop) {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
    );

    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            blob.name = "cropped.jpg";
            resolve(blob);
        }, "image/jpeg");
    });
}

function createImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener("load", () => resolve(img));
        img.addEventListener("error", (error) => reject(error));
        img.setAttribute("crossOrigin", "anonymous"); // Avoid CORS
        img.src = url;
    });
}
